import React from "react";
import { useMe } from "../../users/hooks/useMe";

export const Commercial: React.FC = () => {
  const { data: meData, loading } = useMe();

  if (loading) return <div>Loading...</div>;
  if (!meData?.me) return <div>Not found</div>;

  return (
    <>
      <div className="main-container">
        <section className="section">
          <div className="element">
            <div className="card mb-2"></div>
          </div>
        </section>
      </div>
    </>
  );
};
